import { isBooleanControl, rankWith } from '@jsonforms/core';
import controlRenderer from './BooleanControlRenderer.vue';

export const entry = {
  renderer: controlRenderer,
  tester: rankWith(1, isBooleanControl),
};
